import classnames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';

const PhoneControlsActionContainerButtonContainer = ({ children, className }) => {
  return <div className={classnames('phoneControlsActionContainer-buttonContainer', className)}>{children}</div>;
};

PhoneControlsActionContainerButtonContainer.propTypes = {
  children: PropTypes.any.isRequired,
  className: PropTypes.string,
};

export default PhoneControlsActionContainerButtonContainer;



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/phone_controls/lib/phone_controls_action_container_button_container.jsx